import { render } from "./SecurityTrainingPage.vue?vue&type=template&id=00391a6d"
import script from "./SecurityTrainingPage.vue?vue&type=script&lang=js"
export * from "./SecurityTrainingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__